export default __webpack_public_path__ + "media/zurb/img/home/Netflix-2b4da0249a806b95cf20423e3bc4437c.png";